module.exports = __webpack_public_path__ + "static/media/close-icon-white.da07a458.svg";